// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomCheckBox_root__3xCLV","input":"CustomCheckBox_input__3cobB","ellipse":"CustomCheckBox_ellipse__1Drlf","text":"CustomCheckBox_text__1W3if"};